import searchIcon from "assets/images/search-icon.svg";
import xIcon from "assets/images/x-gray-circle-icon.svg";
import classNames from "classnames";
import {useRef} from "react";
import {searchBar as strings} from "strings";

import styles from "./SearchBar.module.css";

type Props = {
  className?: string;
  prompt: string;
  value: string;
  onChange: (value: string) => void;
};

export default function SearchBar(props: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={classNames(styles.searchBarContainer, props.className)}>
      <img className={styles.searchIcon} src={searchIcon} alt="" />
      <input
        type="search"
        className={styles.searchBar}
        ref={inputRef}
        placeholder={props.prompt}
        value={props.value}
        onChange={(event) => {
          props.onChange(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            inputRef.current?.blur();
          }
        }}
      />
      {props.value ? (
        <button
          className={styles.xButton}
          aria-label={strings.delete}
          onClick={() => props.onChange("")}
        >
          <img src={xIcon} alt="" />
        </button>
      ) : null}
    </div>
  );
}
